<template>
  <div class="px-4 py-1 text-center text-sm text-slate-500">
    Enter at least 2 characters to search.
  </div>
</template>
